import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 17", "Double Chevron Right", /*#__PURE__*/_jsx("path", {
  d: "m5.92 12.85 4.36-4.34-4.36-4.36-.7.7 3.65 3.66-3.65 3.64.7.7z"
}), /*#__PURE__*/_jsx("path", {
  d: "m10.42 12.85 4.36-4.34-4.36-4.36-.7.7 3.65 3.66-3.65 3.64.7.7z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconDoubleChevronRight";
export default Icon;